import {GridContainer, Image, ImageProps, Typography} from '../';
import React from 'react';
import styled from 'styled-components';
import {ArticleCopy} from './ArticleCopy';
import Grid from '@material-ui/core/Grid';

const MetaContainer = styled.div`
    &#metaContent {
        strong {
            font-weight: 600;
            line-height: 22px;
            letter-spacing: 0.2px;
            display: inline-block;
            margin: 0;
        }
        p {
            margin: 0 0 16px 0;
        }
    }
`;

export interface ArticleMetaCopyProps {
    image?: ImageProps;
    metaContent?: string;
    title?: string;
    copy?: string;
}

export const ArticleMetaCopy = ({
    image,
    metaContent,
    title = '',
    copy = ''
}: ArticleMetaCopyProps): JSX.Element => {
    return (
        <GridContainer>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={3} md={2}>
                    <MetaContainer id="metaContent">
                        <Grid container spacing={4}>
                            {image && image.src ? (
                                <>
                                    <Grid item xs={4} md={12}>
                                        <Image height={114} {...image} />
                                    </Grid>
                                    <Grid item xs={8} md={12}>
                                        <Typography variant="p">{metaContent}</Typography>
                                    </Grid>
                                </>
                            ) : (
                                <Grid item xs={12}>
                                    <div className="meta-no-image">
                                        <Typography variant="p">{metaContent}</Typography>
                                    </div>
                                </Grid>
                            )}
                        </Grid>
                    </MetaContainer>
                </Grid>
                <Grid item xs={12} sm={9} md={8}>
                    <ArticleCopy title={title} copy={copy} noGridContainer />
                </Grid>
                <Grid item xs={12} sm={1} md={2} />
            </Grid>
        </GridContainer>
    );
};
